import { Link } from "@inertiajs/react"

import { cn } from "@/lib/utils"

// One profile stat, rendered as an Inertia link into the surface it summarizes
// (Active/Completed → Projects, Freelancers hired → Find Freelancers, Reward
// points → Rewards). Value in the display font; label in ink-3.
export default function StatTile({ href, label, value, Icon }) {
  return (
    <Link
      href={href}
      className={cn(
        "flex flex-col gap-2 rounded-2xl border border-border bg-card px-[18px] py-4 no-underline transition-colors",
        "hover:border-line-2"
      )}
    >
      <span className="grid size-[30px] place-items-center rounded-[9px] border border-border bg-secondary">
        <Icon className="size-[15px] text-muted-foreground" strokeWidth={1.9} />
      </span>
      <span className="font-display text-2xl font-bold tracking-[-0.4px] text-foreground">
        {value ?? 0}
      </span>
      <span className="text-xs font-medium text-ink-3">{label}</span>
    </Link>
  )
}
